var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.79,
    height: 9.382,
    viewBox: "0 0 9.79 9.382",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#b6caff",
    d: "M9.764,4.041a.52.52,0,0,0-.447-.357L6.49,3.427,5.373.812a.521.521,0,0,0-.957,0L3.3,3.427.473,3.684a.521.521,0,0,0-.3.91L2.313,6.467l-.63,2.774a.52.52,0,0,0,.774.563L4.895,8.347,7.331,9.8a.521.521,0,0,0,.775-.563l-.63-2.774L9.612,4.594a.521.521,0,0,0,.152-.553ZM4.941,8.319",
    transform: "translate(0 -0.496)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarBlue);
export default __webpack_public_path__ + "static/media/star-blue.b8dc301a4a3b6cc0055f0a9956068407.svg";
export { ForwardRef as ReactComponent };